export const IsThisYou = () => {
  const statements = [
    "You've been the nice guy your whole life. And you're exhausted.",
    "You say 'I'm fine' so often you've forgotten what honest feels like.",
    "You've tied your worth to what you provide — and it never feels like enough.",
    "You feel guilty for needing time alone.",
    "You're successful. And it feels hollow.",
    "You don't know who you are anymore.",
  ];

  return (
    <section className="py-24 bg-gradient-hero relative">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-16 animate-fade-in">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-primary-foreground mb-4">
              Is This You?
            </h2>
          </div>

          <div className="space-y-6">
            {statements.map((statement, index) => (
              <div
                key={index}
                className="bg-card/10 backdrop-blur border border-primary-foreground/10 rounded-lg p-6 animate-fade-in"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <p className="text-lg md:text-xl text-primary-foreground/90 leading-relaxed italic">
                  "{statement}"
                </p>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center animate-fade-in" style={{ animationDelay: "0.7s" }}>
            <p className="text-2xl md:text-3xl font-display font-bold text-primary-foreground leading-relaxed">
              You're not defective.<br />
              You're not broken.<br />
              <span className="text-accent">You're buried.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
